import React from 'react';
import Table from 'react-bootstrap/Table';
import Moment from 'moment';
import { toDateFormat } from 'utils/helpers/timestampHelper';
import { roundNum } from 'utils/numbers';



const MealsTable = ({nutritionLogs, ...props}) => {
  return (
    <div className="meals-table">
      <Table>
        <thead>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>TYPE</th>
            <th>NAME</th>
            <th>SERVINGS</th>
            <th>GRAMS</th>
            <th>CALORIES</th>
            <th>FAT</th>
            <th>CARBS</th>
            <th>PROTEIN</th>
            <th>LITERS</th>
          </tr>
        </thead>
        <tbody>
        {
          nutritionLogs.map((log, i) => {
            return (
              <tr key={i}>
                <td>{ Moment(toDateFormat(log.created_at)).format('DD-MM-YYYY') }</td>
                <td>{ Moment(toDateFormat(log.created_at)).format('LT') }</td>
                <td>{ log.type }</td>
                <td>{ log.name ? log.name : '-' }</td>
                <td>{ log.serving_size ? roundNum(log.serving_size) : 1 }</td>
                <td>{ log.total_grams ? roundNum(log.total_grams) : '-' }</td>
                <td>{ log.total_calories ? roundNum(log.total_calories) : '-' }</td>
                <td>{ log.total_fat ? roundNum(log.total_fat) : '-' }</td>
                <td>{ log.total_carbs ? roundNum(log.total_carbs) : '-' }</td>
                <td>{ log.total_protein ? roundNum(log.total_protein) : '-' }</td>
                <td>{ log.liters ? roundNum(log.liters) : '-' }</td> 
              </tr>
            )
          })
        }
        </tbody>
      </Table>
    </div>
  );
}

export default MealsTable;
